module.exports = __webpack_public_path__ + "img/shixiao.d7e46d30.svg";